import { render, staticRenderFns } from "./workflowPermission.vue?vue&type=template&id=645b1f8f&"
import script from "./workflowPermission.vue?vue&type=script&lang=ts&"
export * from "./workflowPermission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports